import { ReactNode, useCallback, useMemo } from "react";
import { useQuery } from "urql";

import { getFragmentData, graphql } from "@/gen";
import { useAuth } from "@/hooks/useAuth";

import { ViewerContext, ViewerContext_Viewer } from "./context";

export const ViewerContextProvider = ({ children }: { children: ReactNode }) => {
    const { authUser } = useAuth();

    const [viewerResult, refetch] = useQuery({
        query: graphql(`
            query viewerQuery {
                viewer {
                    ...ViewerContext_Viewer
                }
            }
        `),
        pause: !authUser?.uid,
    });

    const wrappedRefetch = useCallback(async () => {
        refetch();
    }, [refetch]);

    const value = useMemo(() => {
        const viewer = getFragmentData(ViewerContext_Viewer, viewerResult.data?.viewer);
        return {
            viewer: viewer
                ? {
                      ...viewer,
                  }
                : undefined,
            loading: viewerResult.fetching,
            refetch: wrappedRefetch,
            error: viewerResult.error,
        };
    }, [viewerResult.data?.viewer, viewerResult.error, viewerResult.fetching, wrappedRefetch]);

    return <ViewerContext.Provider value={value}>{children}</ViewerContext.Provider>;
};
